import { PartnerSlider } from "./components/Partner-slider"
import React from "react"

export default function BrandSliderDemo() {
  return (
    <div className="brand-slider-demo">
      <PartnerSlider />
    </div>
  )
} 